import { AppEnvironment } from './app-environment.model';

const baseUrl = window.location.origin;

const oAuthConfig = {
  issuer: 'https://identity.cx.sestek.localdev/',
  redirectUri: baseUrl,
  clientId: 'AgenticCX_App',
  responseType: 'code',
  scope: 'offline_access AgenticCX',
  requireHttps: true,
  impersonation: {
    userImpersonation: true,
    tenantImpersonation: true,
  },
};

export const environment = {
  production: true,
  application: {
    baseUrl,
    name: 'AgenticCX | SESTEK',
  },
  oAuthConfig,
  serverConfig: {
    uploadMaxFileSize: 100 * 1024 * 1024,
  },
  apis: {
    default: {
      url: '',
      rootNamespace: 'Sestek.AgenticCX',
    },
    AbpAccountPublic: {
      url: oAuthConfig.issuer,
      rootNamespace: 'AbpAccountPublic',
    },
  },
  remoteEnv: {
    url: '/api/host/environment/dynamic',
    mergeStrategy: 'deepmerge',
  },
  stateNameSpace: 'AgenticCX',
} as AppEnvironment;
